<!--<ion-grid fixed class="page-grid">-->

<!--refresher-->
<ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100" (ionRefresh)="refresh($event)">
    <ion-refresher-content></ion-refresher-content>
</ion-refresher>
<!--refresher end-->


<ion-row *transloco="let t; read: 'profileBarComp'" class="wrapper-page ion-align-items-start">

    <ion-col size="12" class="ion-hide-lg-up ion-no-padding">
        <app-main-notification
            *ngIf=" this.student?.hasNotPaidNotifications || this.student?.inReservedNotifications || this.hasNotPaidCourses"
            [hasNotPaid]="this.student?.hasNotPaidNotifications || this.hasNotPaidCourses"
            [inReserved]="this.student?.inReservedNotifications"
            [childName]="this.student?.firstName"
            [withMarginBottom]="true">

        </app-main-notification>

        <app-main-notification

            *ngIf="this.student?.studentComment"
            [studentComment]="this.student?.studentComment"
            [childName]="this.student?.firstName"
            [withMarginBottom]="true"
        ></app-main-notification>
    </ion-col>

    <ion-col size-lg="4" size-md="12" size-sm="12" size-xs="12" class="profile-bar">

        <ion-accordion-group class="ion-padding-bottom" #accordionGroup>
            <ion-accordion value="first">
                <ion-item slot="header" class="my-children" (click)="toggleHideChildCard()">
                    <ion-label>{{ t('myChildren') }}</ion-label>
                </ion-item>

                <div *ngFor="let child of children$ | async;"
                     class="ion-padding ion-margin-top  ion-margin-bottom child-profile-card"
                     [ngClass]="{'active-child' : child.id === this.activeChild.id }" slot="content"
                     (click)="chooseActiveChild(child)">

                    <app-child-card
                        [child]="child"
                        [showActive]="child.id === this.activeChild.id"
                    >
                    </app-child-card>

                </div>


                <button type="button" class="btn-add-child" slot="content" id="open-modal" expand="block">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9L11.25 11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H11.25V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15L12.75 12.75H15C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H12.75V9Z"
                              fill="#3F403F"/>
                    </svg>
                    {{ t('addChild') }}
                </button>

            </ion-accordion>
        </ion-accordion-group>

        <div class="ion-padding ion-margin-bottom child-profile-card" *ngIf="!hideChildCard">

<!--            <ng-container *ngIf="activeChild$ | async as child;">-->
<!--                <app-child-card-->
<!--                    [child]="child"-->
<!--                    [canEnterStyle2]='true'-->
<!--                    (enterStudentCabinet)="this.enterAsActiveStudent(child)"-->
<!--                    (reloadDashboard)="this.reloadPage(child)"-->
<!--                >-->
<!--                </app-child-card>-->
<!--            </ng-container>-->

            <ng-container *ngFor="let child of children$ | async;">
                <app-child-card *ngIf="child.id ==this.activeChild.id"
                    [child]="child"
                    [canEnterStyle2]='true'
                    (enterStudentCabinet)="this.enterAsActiveStudent(child)"
                    (reloadDashboard)="this.reloadPage(child)"
                >
                </app-child-card>
            </ng-container>
        </div>

        <ion-list [inset]="true">
            <ion-item class="content-btn light-yellow-background" (click)="goToPage('/loyalty-program')">
                <div class="wrapper-btn">
                    <div>
                        <div class="content-inner">
                            <img alt="coins" src="assets/images/icons/coins.svg" class="ion-padding-end"/>
                            {{ t('programs') }}
                        </div>

                        <div
                            [innerHTML]=" t('saved', {amount: this.student?.moneyBalance ? this.student?.moneyBalance: '0', currency: t('grn') })">
                        </div>
                    </div>

                    <div class="arrow">
                        <img alt="right" src="assets/images/icons/arrow-right.svg"/>
                    </div>
                </div>


            </ion-item>

            <ion-item class="content-btn light-green-background ion-margin-top"
                      (click)="goToPage('/study-history')">

                <div class="wrapper-btn">
                    <div class="content-inner">
                        <img alt="coins" src="assets/images/icons/history.svg" class="ion-padding-end"/>
                        {{ t('history') }}
                    </div>

                    <div class="arrow">
                        <img alt="right" src="assets/images/icons/arrow-right.svg"/>

                    </div>
                </div>

            </ion-item>
        </ion-list>

        <div class="ion-hide-sm-down" *ngIf="this.activeTabGroups && !isSmallScreen()">

            <div *ngFor="let group of this.activeTabPaidGroups">
                <app-group-info
                    *ngIf="!group.isReserve"
                    [group]="group"
                    [class]="group.color === '80b0b2' ? 'light-blue-bg' : group.color === 'EBC700' ? 'yellow-bg': 'green-bg'"
                    [title]=" t('group')"
                    [groupTitle]="group.title"
                    [withMarginBtn]="true"
                ></app-group-info>
            </div>
        </div>

        <app-student-actions *ngIf="this.activeTabPaidGroups && this.showStudentActions" class="ion-hide-lg-down"
                             [groups]=" this.activeTabPaidGroups"
        ></app-student-actions>


    </ion-col>

    <ion-col size-lg="8" size-md="12" size-sm="12" class="info-block">

        <app-main-notification class="ion-hide-lg-down"
                               *ngIf=" this.student?.hasNotPaidNotifications || this.student?.inReservedNotifications ||this.hasNotPaidCourses"
                               [hasNotPaid]="this.student?.hasNotPaidNotifications  || this.hasNotPaidCourses"
                               [inReserved]="this.student?.inReservedNotifications"
                               [childName]="this.student?.firstName"
                               [withMarginBottom]="true"
        ></app-main-notification>

        <app-main-notification class="ion-hide-lg-down"
                               *ngIf="this.student?.studentComment"
                               [studentComment]="this.student?.studentComment"
                               [childName]="this.student?.firstName"
                               [withMarginBottom]="true"
        ></app-main-notification>


        <app-tabs *ngIf="studentHasGroups=== true" [styleGroup]="true" (changeTab)="onTabChange($event)">

            <app-tab [tabTitle]="t('currentCourses')" [svg]="true" [active]="activeCurrentGroupsTabs"
                     [time]="'isCurrent'">
                <ion-row class="study-content ion-no-padding">

                    <div *ngFor="let group of this.activeTabGroups">

                        <app-reserved
                            *ngIf=" group.time ==='isCurrent' && (group.isReserve || group.debts.debt_amount> 0)"
                            [group]="group" class="ion-margin-bottom">
                        </app-reserved>

                    </div>



                    <div *ngFor="let group of this.activeTabGroups"
                         [ngClass]="{'d-none': group.time!=='isCurrent'}">


                        <!--                        remove group.debts.has_paid from the  *ngIf= for app-reserved  and  app-group-->

                        <ion-col size="12" *ngIf="group.time ==='isCurrent'" class="ion-no-padding ion-no-margin">
                            <app-group *ngIf="!group.isReserve"
                                       [group]="group"
                                       [class]="group.color === '80b0b2' ? 'light-blue-bg' : group.color === 'EBC700' ? 'yellow-bg': 'green-bg'"
                            >

                            </app-group>

                            <!--                            <app-reserved *ngIf="group.isReserve || group.debts.debt_amount> 0"-->
                            <!--                                          [group]="group" class="ion-margin-bottom">-->
                            <!--                            </app-reserved>-->

                        </ion-col>

                    </div>

                    <ion-col *ngIf="this.activeTabGroups && this.activeTabGroups.length == 0">
                        <app-no-course-notice [currentGroup]="true"></app-no-course-notice>
                    </ion-col>


                </ion-row>
            </app-tab>

            <app-tab [tabTitle]="t('futureCourses')" [svg]="true" [active]="activeFuturesGroupsTabs"
                     [time]="'isFuture'">
                <ion-row class="study-content ion-no-padding">

                    <div *ngFor="let group of this.activeTabGroups">

                        <app-reserved
                            *ngIf=" group.time ==='isFuture' && (group.isReserve || group.debts.debt_amount> 0)"
                            [group]="group" class="ion-margin-bottom">
                        </app-reserved>

                    </div>


                    <div *ngFor="let group of this.activeTabGroups"
                         [ngClass]="{'d-none': group.time!=='isFuture'}">

                        <ion-col size="12" *ngIf="group.time ==='isFuture'" class="ion-no-padding ion-no-margin">
                            <app-group *ngIf="!group.isReserve"
                                       [group]="group"
                                       [class]="group.color === '80b0b2' ? 'light-blue-bg' : group.color === 'EBC700' ? 'yellow-bg': 'green-bg'"
                            >

                            </app-group>

                            <!--                            <app-reserved *ngIf="group.isReserve || group.debts.debt_amount> 0"-->
                            <!--                                          [group]="group">-->
                            <!--                            </app-reserved>-->

                        </ion-col>

                    </div>

                    <ion-col *ngIf="this.activeTabGroups && this.activeTabGroups.length == 0">
                        <app-no-course-notice [futureGroup]=true></app-no-course-notice>
                    </ion-col>


                </ion-row>
            </app-tab>
            <app-tab [tabTitle]="t('passedCourses')" [svg]="true" [active]="activePassedGroupsTabs" [time]="'isPast'">
                <ion-row class="study-content ion-no-padding">

                    <div *ngFor="let group of  this.activeTabGroups">

                        <app-reserved
                            *ngIf=" group.time ==='isPast' && (group.isReserve || group.debts.debt_amount> 0)"
                            [group]="group" class="ion-margin-bottom">
                        </app-reserved>

                    </div>


                    <div *ngFor="let group of  this.activeTabGroups"
                         [ngClass]="{'d-none': group.time!=='isPast'}">

                        <ion-col size="12" *ngIf="group.time ==='isPast'" class="ion-no-padding ion-no-margin">
                            <app-group *ngIf="!group.isReserve"
                                       [group]="group"
                                       [class]="group.color === '80b0b2' ? 'light-blue-bg' : group.color === 'EBC700' ? 'yellow-bg': 'green-bg'"
                            >

                            </app-group>

                            <!--                            <app-reserved *ngIf="group.isReserve || group.debts.debt_amount> 0"-->
                            <!--                                          [group]="group">-->
                            <!--                            </app-reserved>-->

                        </ion-col>

                    </div>
                    <ion-col *ngIf="this.activeTabGroups && this.activeTabGroups.length == 0">
                        <app-no-course-notice [pastGroup]=true></app-no-course-notice>
                    </ion-col>

                </ion-row>
            </app-tab>

        </app-tabs>

        <div *ngIf="studentHasGroups===false">

            <ion-row class="certificate-content"
                     *ngIf="this.student?.hasEnterTest && !this.student?.onlineTestRequired && this.student?.toShowEnglishLevelResult && !this.student?.isItBeforeSchoolChild">
                <ion-col size="12" class="ion-no-padding ion-no-margin ">

                    <app-new-student-info [title]="this.student?.levelTitle" [withButtonRequest]="true"
                                          [beforeSchool]="this.student?.isItBeforeSchoolChild"
                                          [parentDashboard]="true"
                                          [secondTryTestLink]="this.student?.onlineTestRequiredSecondTime"
                    ></app-new-student-info>

                </ion-col>

            </ion-row>


            <ion-row class="greeting-content ion-no-padding">

                <ion-col size="12" class="video-greeting">

                    <div class="title">

                        {{ t('aboutStudies') }}
                    </div>
                    <div class="video-greeting-wrapper">

                        <iframe class="embed-responsive-item" width="100%" height="100%"
                                [src]="this.saveVideoLink" allow="autoplay; encrypted-media"
                                allowfullscreen></iframe>

                    </div>

                    <div class="btn-wrapper"
                         *ngIf="(!this.student?.hasEnterTest && this.student?.onlineTestRequired) || (!this.student?.hasEnterTest && this.student?.levelTitle) || this.student?.onlineTestRequired || (this.student?.hasEnterTest && !this.student?.onlineTestRequired && !this.student?.toShowEnglishLevelResult) || this.student?.isItBeforeSchoolChild">

                        <button type="button" class="btn dark-btn" (click)="openRequestModal('continueStudy')">
                            {{ t('request') }}
                        </button>
                    </div>


                </ion-col>

            </ion-row>
        </div>


        <app-banners *ngIf="this.student?.banners" [banners]="this.student?.banners"></app-banners>

        <app-feedback *ngIf="this.student?.totalGroupAmount"></app-feedback>


    </ion-col>


</ion-row>


<ion-modal class="new-student-modal auto-height"  *transloco="let t; read: 'profileBarComp'"  trigger="open-modal" (willDismiss)="onWillDismiss($event)">
    <ng-template>
    <div class="inner-content">
        <div class="wrapper">
            <div class="text">
                {{ t('newStudentTitle') }}

            </div>

            <div class="text">
                {{ t('newStudentText') }}
            </div>

            <div class="close" (click)="close()">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                          fill="#83B25F"/>
                </svg>

            </div>


            <button type="submit" class="btn dark-btn" (click)="confirm()">     {{ t('newStudentBtn') }}</button>


        </div>


    </div>
    </ng-template>
</ion-modal>


<!--</ion-grid>-->


